// Components
import { Button } from "@mui/material";

const ExamCardButton = ({ updateValue, label, isSelected, isDisabled }) => {
  return (
    <Button
      sx={{
        backgroundColor: isSelected ? "#E2772E" : "#5B6D7A",
        color: "#FFF",
        fontSize: "14px",
        fontWeight: 600,
        borderRadius: "4px",
        padding: "4px 0px",
        width: "100%",
        minWidth: "fit-content",

        "&:hover": {
          backgroundColor: isSelected ? "#CE631A" : "#475966",
        },

        "&.Mui-disabled": {
          color: "#FFF",
          backgroundColor: "#435B6D7A",
        },
      }}
      onClick={updateValue}
      disabled={isDisabled}
    >
      {label}
    </Button>
  );
};

export default ExamCardButton;
